import { useState, useEffect } from "react";
import { FormGroup, Table, Card, CardHeader, CardFooter, CardText, CardBody, Button } from 'reactstrap';
import '../GerenciamentoTurmas/GerenciamentoTurmas.css'

const ListaRegistroPorResponsavel = ({ aluno, putAluno }) => {

    const renderListResponsaveis = () => {
        let renderedList = [];
        let responsaveis = aluno.resposaveis;
        responsaveis.map((responsavel) => {
            renderedList.push(renderResponsavelSingle(responsavel));
        })

        return renderedList;
    }

    const renderResponsavelSingle = (responsavel) => {
        return (
            <>
                <Button className="submitRegistrosButton" onClick={() => { putAluno(responsavel) }}>
                        {responsavel['nome']}
                </Button>
            </>
        );
    }

    return (
        <>
            <FormGroup>
                <div className="ListaResponsaveis">
                    {(aluno === null || aluno === undefined) ? (<tr> <td> none </td></tr>) : (renderListResponsaveis())}
                </div>
            </FormGroup>
        </>
    );
}

export default ListaRegistroPorResponsavel;